import { FunctionalComponent, h } from 'preact';
import Selector from '../Selector';
import { languageList } from './LanguageList';
import { memo } from 'preact/compat';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Props = {
  onChange: (selected: string) => void;
};

const LanguageSelector: FunctionalComponent<Props> = memo(({ onChange }) => {
  const { core, labels } = useSettingsContext();
  const mappedLanguage =
    core?.language.available.sort().map((language) => {
      return {
        ariaLabel: languageList[language.toUpperCase() as keyof typeof languageList]?.language,
        displayName: languageList[language.toUpperCase() as keyof typeof languageList]?.displayName,
        value: language.toUpperCase(),
      };
    }) || [];

  if (!core || !labels || core.language.available.length <= 1) {
    return null;
  }

  return (
    <Selector<string>
      onChange={onChange}
      items={mappedLanguage}
      ariaLabel={labels.ariaLabels.languageSelector}
      defaultItem={{
        ariaLabel: languageList[core.language.selected.toUpperCase() as keyof typeof languageList]?.language,
        displayName: languageList[core.language.selected.toUpperCase() as keyof typeof languageList]?.displayName,
        value: core.language.selected.toUpperCase(),
      }}
      maxHeight={260}
      id="usercentrics-language-selector"
      testIdContainer="uc-language-container"
      testIdMenuButton="uc-language-button"
      testIdMenu="uc-language-menu"
    />
  );
});

export default LanguageSelector;
